import React, { useContext } from "react";
import CustomButton from "../../../components/Button/CustomButton";
import ConfirmationDialogContext from "../../../components/Dialog/ConfirmationDialog/ConfirmationDialogContext";
import { tesaBlue } from "../../../styles/colors";
import ErrorSnackbarContext from "../../../contexts/ErrorSnackbarContext";
import useEnv from "../../../hooks/env";
import TestRequestLifecycleApi from "../../../api/services/TestRequestLifecycleApi";
import TestRequestResponse from "../../../api/models/test-request/TestRequestResponse";

export interface ApproveTestRequestButtonProps {
  disabled?: boolean;
  testRequestName: string;
  handleShowSuccessMessage: () => void;
  preSave: () => Promise<TestRequestResponse | void>;
  onSuccess: (testRequest: TestRequestResponse) => void;
  style: any;
}

const ApproveTestRequestButton: React.FC<ApproveTestRequestButtonProps> = (props) => {
  const { disabled, handleShowSuccessMessage, preSave, onSuccess, testRequestName, style } = props;
  const { api } = useEnv();
  const testRequestLifecycleApi = new TestRequestLifecycleApi(api);
  const { showConfirmationDialog } = useContext(ConfirmationDialogContext);
  const { handleHttpError } = useContext(ErrorSnackbarContext);

  const setSubmissionStatus = (id: string) => {
    testRequestLifecycleApi
      .approveTestRequest(id)
      .then((value) => {
        handleShowSuccessMessage();
        return value.data as TestRequestResponse;
      })
      .then(onSuccess)
      .catch(handleHttpError);
  };

  const onApprove = () => {
    showConfirmationDialog({
      text: (
        <>
          Approve test request: <b>{testRequestName}</b> and send it to the CSC.
        </>
      ),
      confirmText: "Approve",
      confirmColor: tesaBlue,
    })
      .then(() =>
        preSave().then((res) => {
          if (res && res?.requestId) {
            setSubmissionStatus(res?.requestId);
          }
        }),
      )
      .catch(handleHttpError);
  };

  return <CustomButton disabled={disabled} onClick={onApprove} primary text="Approve" style={style} />;
};

export default ApproveTestRequestButton;
